import Modal from "./Modal";
import HubspotForm from "react-hubspot-form";
import Menu from "./Menu";
import { NavLink } from "react-router-dom";

import "../css/header.css";

import image1 from "../img/utpl.png";

function Header() {
  return (
    <>
      <div className="wrapper-header">
        <div className="layout8">
          <div className="logo ">
            {/*
            <div>
              <Menu></Menu>
            </div>
*/}
            <div>
              <NavLink to="/">
                <img src={image1} alt="utpl" className="logo"></img>
              </NavLink>
            </div>
          </div>

          <div className="menu-items">
             <Menu></Menu>
          

            {/*
            <NavLink to="/matriculas" className="header-opmobile">
              Matricúlate ahora
            </NavLink>

            <Modal
              title="Solicita información"
              content={
                <>
                  <div className="wrapper-blockformutpl header-form">
                    <div className="layout8">
                      <h3>Solicita información</h3>
                      <div className="formutpl">
                        <HubspotForm
                          portalId="3056987"
                          formId="09e4a84a-50f8-45d6-a81f-8c4eab9a82be"
                          css=""
                        />
                      </div>
                    </div>
                  </div>
                </>
              }
            ></Modal> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
